export {featureName, currentProjectReducer} from './current-project.reducer';
export {featureReducer} from './feature.reducer';



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/core/reducers/index.ts